import ModalDialog from 'src/components/ModalDialog';
import { useForm } from 'src/components/Form';
import { RequestMethod, pepApiRequest, useStatefulApi } from 'src/services';
import { generatePath, useParams } from 'react-router-dom';
import { AlertType, useAlert } from 'src/components/AlertsProvider';
import { useStoreUnitActions } from 'src/redux/helpers';
import { SignatureWhitelistFormFields } from '../formFields';
import { SolutionSignatureWhitelistItem } from '../../types';
import solutionsStore from '../../redux';
import { API_OS_WHITELIST } from '../../constants';

type Props = {
  title: string;
  item: SolutionSignatureWhitelistItem;
  open: boolean;
  onClose: () => void;
};

function SignatureWhitelistCreateModal({ item, title, open, onClose }: Props) {
  const { solutionId } = useParams();
  const { showAlert } = useAlert();
  const actions = useStoreUnitActions(solutionsStore);
  const [onSubmit, loading] = useStatefulApi(
    (operatingSystems) =>
      pepApiRequest({
        method: RequestMethod.Post,
        url: generatePath(API_OS_WHITELIST, { solutionId }),
        params: { operatingSystems: [operatingSystems] },
      }),
    () => {
      showAlert({
        type: AlertType.Success,
        title: 'OS signature Whitelist created',
        text: 'OS signature whitelist has been successfully created.',
      });
      actions.signatureWhitelist(solutionId);
      onClose();
    }
  );

  const [form, handleSubmit] = useForm({
    values: item,
    fields: SignatureWhitelistFormFields,
    onSubmit,
  });

  return (
    <ModalDialog
      open={open}
      title={title}
      loading={loading}
      onClose={onClose}
      onConfirm={handleSubmit}
      confirmBtnText="Save"
      fullWidth
    >
      {form}
    </ModalDialog>
  );
}

export default SignatureWhitelistCreateModal;
